import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Flex, ScaleFade, Box, Text, Button } from '@chakra-ui/react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { HeaderUp } from '../../../components/_components_0.2/Header_0.2';
import { Sidebar } from '../../../components/_components_0.2/Sidebar_0.2';
import Select from '../../../components/Global/Select';
import { Card } from '../../../components/_components_0.2/Card';

import Plan from './InvestimentPlan';

// import banner from '../../../assets/Adesivo.jpg';
import { api } from '../../../services/api';
import getValidationErrors from '../../../utils/getValidationErrors';
import { useCan } from '../../../hooks/useCan';

interface IOptions {
  value: string;
  label: string;
}

export default function Pic() {
  const formRef = useRef<FormHandles>(null);
  const [sectors, setSectors] = useState<IOptions[]>([]);
  const [sectorSelected, setSectorSelected] = useState('');

  const userCanSeeDataPic = useCan({
    permissions: ['data_pic'],
  });

  useEffect(() => {
    try {
      api.get('/sectors').then(response => {
        const sectorFormateded: React.SetStateAction<any[]> = [];

        response.data.forEach(function (sector: { id: string; name: string }) {
          const option = {
            value: sector.id,
            label: sector.name,
          };
          sectorFormateded.push(option);
        });

        setSectors(sectorFormateded);
      });
    } catch (err) {
      console.log(err);
    }
  }, []);

  const handleSubmit = useCallback(data => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        sector: Yup.string().required('setor é obrigatório'),
      });

      schema.validate(data, {
        abortEarly: false,
      });

      setSectorSelected(data.sector);
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);

        formRef.current?.setErrors(errors);
      }
    }
  }, []);

  return (
    <ScaleFade initialScale={0.9} in>
      <Flex direction="column" h="100vh">
        <HeaderUp path="bi" />
        <Flex maxWidth={1480} mx="auto" textAlign="center">
          <Sidebar path="bi" />
          <Box>
            {/* <Image src={banner} h={40} borderRadius="lg" /> */}
            {/* <Card minH="xs" p="2">
            </Card> */}

            <Card minH="1xs" mt="15px" bg="transparent">
              <Flex alignItems="center" flexDirection="column">
                <Box>
                  <Box>
                    <Text fontSize="4xl" mb="4" fontWeight="medium">
                      Plano de investimento COOASGO 2027
                    </Text>

                    <Text>
                      Neste momento você ira preencher o formulário do PIC 2027.
                    </Text>
                  </Box>
                  <Box mt="25px" textAlign="start">
                    <Text fontWeight="black">Considerações importantes</Text>
                    <Text>* O planejamento será encerrado em 20/10/2026.</Text>
                    <Text>
                      * Após a data de encerramento não será possivel preencher
                      tal formulário.
                    </Text>

                    <Box
                      mt="15px"
                      p="20px"
                      borderRadius="12px"
                      bg="orange.50"
                      border="1px solid"
                      borderColor="orange.200"
                      boxShadow="sm"
                      textAlign="center"
                    >
                      <Text
                        color="orange.800"
                        fontWeight="medium"
                        fontSize="md"
                        mb="3"
                        lineHeight="1.6"
                      >
                        IMPORTANTE: Leia atentamente todas as instruções dos
                        materiais em anexo antes de realizar o preenchimento do
                        PIC 2027.
                      </Text>
                      <Flex justify="center" wrap="wrap" gap="3">
                        {[
                          {
                            label: '📄 Clique aqui para baixar o material',
                            href: 'https://cooasgocoop.sharepoint.com/:b:/g/IQDSdmV20O1yRJNg3-DegLQlAUw13QbuqXn2OZJesOEza2M?e=veVe8U',
                          },
                          {
                            label:
                              '📄 IT nº 032 PIC - Plano de Investimento COOASGO',
                            href: 'https://cooasgocoop.sharepoint.com/:b:/g/IQBkIb6Jq_UDQ4hc-QUCMDH8AWewaBKLy1f8lUfxIKBhFIs?e=hfezks',
                          },
                        ].map(file => (
                          <a
                            key={file.href}
                            href={file.href}
                            target="_blank"
                            rel="noreferrer"
                            style={{ textDecoration: 'none' }}
                          >
                            <Text
                              color="orange.700"
                              fontWeight="semibold"
                              fontSize="sm"
                              bg="orange.100"
                              px="4"
                              py="2"
                              borderRadius="md"
                              display="inline-block"
                              _hover={{ bg: 'orange.200' }}
                              transition="all 0.2s"
                            >
                              {file.label}
                            </Text>
                          </a>
                        ))}
                      </Flex>
                    </Box>
                  </Box>
                </Box>
              </Flex>
            </Card>

            {userCanSeeDataPic && (
              <Box mt="25px" mb="35px" h="50px" w="500px" textAlign="start">
                <Text>Filtro</Text>
                <Form ref={formRef} onSubmit={handleSubmit}>
                  <Box display="flex" flexDirection="row">
                    <Box w="300px" mr="15x">
                      <Select name="sector" options={sectors} />
                    </Box>
                    <Button
                      type="button"
                      colorScheme="gray"
                      ml="5"
                      disabled={sectorSelected === ''}
                      onClick={() => setSectorSelected('')}
                    >
                      Limpar
                    </Button>
                    <Button type="submit" colorScheme="blue" ml="2">
                      Aplicar
                    </Button>
                  </Box>
                </Form>
              </Box>
            )}

            <Box mt="3rem" mb="8rem">
              <Plan />
            </Box>
          </Box>
        </Flex>
      </Flex>
    </ScaleFade>
  );
}
